import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../hasInterface';
import Coordinate from '../geom/Coordinate';
import CoordinateSequence from '../geom/CoordinateSequence';
var Area = /*#__PURE__*/function () {
  function Area() {
    _classCallCheck(this, Area);
  }
  _createClass(Area, null, [{
    key: "ofRing",
    value: function ofRing() {
      if (arguments[0] instanceof Array) {
        var ring = arguments[0];
        return Math.abs(Area.ofRingSigned(ring));
      } else if (hasInterface(arguments[0], CoordinateSequence)) {
        var _ring = arguments[0];
        return Math.abs(Area.ofRingSigned(_ring));
      }
    }
  }, {
    key: "ofRingSigned",
    value: function ofRingSigned() {
      if (arguments[0] instanceof Array) {
        var ring = arguments[0];
        if (ring.length < 3) return 0.0;
        var sum = 0.0;
        var x0 = ring[0].x;
        for (var i = 1; i < ring.length - 1; i++) {
          var x = ring[i].x - x0;
          var y1 = ring[i + 1].y;
          var y2 = ring[i - 1].y;
          sum += x * (y2 - y1);
        }
        return sum / 2.0;
      } else if (hasInterface(arguments[0], CoordinateSequence)) {
        var _ring2 = arguments[0];
        var n = _ring2.size();
        if (n < 3) return 0.0;
        var p0 = new Coordinate();
        var p1 = new Coordinate();
        var p2 = new Coordinate();
        _ring2.getCoordinate(0, p1);
        _ring2.getCoordinate(1, p2);
        var _x = p1.x;
        p2.x -= _x;
        var _sum = 0.0;
        for (var _i = 1; _i < n - 1; _i++) {
          p0.y = p1.y;
          p1.x = p2.x;
          p1.y = p2.y;
          _ring2.getCoordinate(_i + 1, p2);
          p2.x -= _x;
          _sum += p1.x * (p0.y - p2.y);
        }
        return _sum / 2.0;
      }
    }
  }]);
  return Area;
}();
export { Area as default };